// extracted by mini-css-extract-plugin
export var panelWrapper = "projects-module--panelWrapper--3PfuE";
export var projectsSection = "projects-module--projectsSection--WMspW";
export var subColor = "projects-module--subColor--Wbj1-";